import { motion } from 'framer-motion';
import React from 'react';
interface CardProps {
  children: React.ReactNode;
  y?: string;
}
export const BounceFadeMotionBox = (props: CardProps) => {
  return (
    <motion.div initial={{ y: props.y || '-30px', opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
      {props.children}
    </motion.div>
  );
};
